















































































import { Component, Prop } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { MedicationInstructionPayload } from '@/api/medicationInstruction/types'
import InputGroup from '@/mixins/form/inputGroup'

@Component({
  components: {
    SelectInput: () => import('@/components/common/inputs/SelectInput.vue'),
    RadioInput: () => import('@/components/common/inputs/RadioInput2.vue')
  }
})
export default class EatingInputGroup extends mixins(InputGroup) {
  @Prop(Object) inputs!: MedicationInstructionPayload

  get eatingAppetiteOptions() {
    return [
      { value: 0, label: '無' },
      { value: 1, label: '有' }
    ]
  }

  get eatingMealCountOptions() {
    return [...new Array(21)].map((_, i) => i)
  }

  get eatingMealAmountOptions() {
    return [
      { value: 1, label: '少' },
      { value: 2, label: '適' },
      { value: 3, label: '多' }
    ]
  }

  get eatingDysphagiaOptions() {
    return [
      { value: 0, label: '無' },
      { value: 1, label: '有' }
    ]
  }
}
